<template>
    <div class="container">
        <header class="jumbotron">
            <h3>Lista roli</h3>
        </header>
        <Button type="button" label="Dodaj rolę" v-on:click="click"/>
        <DataTable :value="content" v-model:filters="filters" :loading="loading" removableSort responsiveLayout="scroll"
                   :globalFilterFields="['name']">
            <template #header>
                <div class="p-d-flex p-jc-end">
                        <span class="p-input-icon-left ">
                            <i class="pi pi-search"/>
                            <InputText v-model="filters['global'].value" placeholder="Wyszukaj"/>
                        </span>
                </div>
            </template>
            <template #empty>
                Nie znalieziono roli
            </template>
            <template #loading>
                Ładwanie roli. Proszę czekać
            </template>
            <Column field="name" header="Nazwa" :sortable="true"></Column>
            <Column headerStyle="width: 12em" bodyStyle="text-align: center; display: inline-block;">
                <template #body="slotProps">
                    <Button type="button" label="Edytuj"
                            v-on:click="editUnit(slotProps.data.id)"></Button>
                    <Button type="button" class="p-button-danger" label="Usuń"
                            v-on:click="removeUnit(slotProps.data.id)"></Button>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
    import RolesService from "../../services/roles.service";
    import {FilterMatchMode} from 'primevue/api';

    export default {
        inject: ['global'],
        name: "RolesList",
        data() {
            return {
                content: null,
                filters: {
                    'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                    'name': {value: null, matchMode: FilterMatchMode.STARTS_WITH}
                },
                loading: true,
            };
        },
        methods: {
            click: function () {
                this.$router.push({path: `${this.global.state.instancePatch}/role/dodaj`});
            },
            editUnit: function (id) {
                this.$router.push({path: `${this.global.state.instancePatch}/role/edytuj/${id}`});
            },
            removeUnit: function (id) {
                RolesService.removeRole(id).then(
                    () => {
                        this.getList();
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Usunięto',
                            detail: 'Poprawnie usunięto rolę',
                            life: 3000
                        });
                    },
                    (error) => {
                        this.content =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                    }
                );
            },
            getList: function () {
                RolesService.getAllRoles().then(
                    (response) => {
                        this.loading = false;
                        this.content = response.data.items;
                    },
                    (error) => {
                        this.content =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                    }
                );
            },
        },
        mounted() {
            this.getList();
        },
    };
</script>
